import React, { ReactElement, useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import useRouting, { NavLink, useParams } from "../../contexts/Routing";

import PickRole from "./steps/pick-role";
import PickMode from "./steps/contact-mode";
import TicketingSystem from "./steps/ticketing-system";
import Customize from "./steps/customize";
import AddChannel from "./steps/add-channel";

import { StepProps } from "./steps/base";
import {
    useGetOnboardingProfileQuery, useSaveOnboardingProfileMutation, OnboardingProfile,
    GetOnboardingProfileDocument, useFinishOnboardingMutation,
} from "../../__generated__/api";
import useLogging from "../../contexts/logging/LoggingContext";
import { removeTypename } from "../../api";

interface Step {
    id: string;
    step: (props: StepProps) => ReactElement;
    next?: string;
    previous?: string;
}
const STEPS: Step[] = [
    {
        id: "pick-role",
        step: PickRole,
        next: "contact-mode",
    },
    {
        id: "contact-mode",
        step: PickMode,
        previous: "pick-role",
        next: "ticketing-system",
    },
    {
        id: "ticketing-system",
        step: TicketingSystem,
        previous: "contact-mode",
        next: "add-to-slack",
    },
    // {
    //     id: "customize",
    //     step: Customize,
    //     previous: "ticketing-system",
    //     next: "add-to-slack",

    // },
    {
        id: "add-to-slack",
        step: AddChannel,
        previous: "ticketing-system",
    },

];

export default function Onboarding() : ReactElement | null {
    const { Paths, historyPushWithSearch, historyPush } = useRouting();
    const [profile, setProfile] = useState<OnboardingProfile>({});

    const { data: dbProfile } = useGetOnboardingProfileQuery();
    const [saveProfile] = useSaveOnboardingProfileMutation();
    const [finishOnboarding] = useFinishOnboardingMutation();
    const logging = useLogging();

    useEffect(() => {
        // if (dbProfile) {
        //     setProfile(dbProfile.onboardingProfile ?? {});
        // }
    }, [dbProfile]);

    const { stepId } = useParams(Paths.ONBOARDING_STEP);

    const stepIndex = (stepId ? STEPS.findIndex(current => current.id === stepId) : undefined) ?? 0;
    const step = STEPS[stepIndex];
    const Step = step.step;

    const onDoneOnboarding = async () => {
        await finishOnboarding();
        historyPushWithSearch(Paths.HOME, { isSuccess: "✔️", isOnboarded: "✔️" });
    };
    const storeProfile = async (currentProfile: OnboardingProfile) => {
        await logging.wrap(async () => {
            await saveProfile({
                update: (cache, opt) => {
                    cache.writeQuery({
                        query: GetOnboardingProfileDocument,
                        data: {
                            onboardingProfile: opt.data?.saveOnboardingProfile ?? profile,
                        },
                    });
                },
                variables: {
                    profile: removeTypename({
                        ...currentProfile,
                        isExternalSupport: undefined,
                    }),
                },
            });
        });
        setProfile({ ...currentProfile });
    };

    return (

        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5 align-items-start">

                <Step
                    profile={profile}
                    onSaveProfile={currentProfile => {
                        storeProfile(currentProfile);
                    }}
                    onNext={async currentProfile => {
                        await storeProfile(currentProfile);
                        if (step.next) {
                            historyPush(Paths.ONBOARDING_STEP, { stepId: step.next });
                        } else {
                            historyPush(Paths.AGENT);
                        }
                    }}
                />
                <div className="d-flex justify-content-between align-items-center gap-4 mt-4 w-100">
                    {step.previous ? (
                        <NavLink
                            className="text-light text-center btn btn-link p-0 m-0 "
                            to={Paths.ONBOARDING_STEP}
                            params={{ stepId: step.previous }}
                        >
                            Back
                        </NavLink>
                    ) : (
                        <div />
                    ) }

                    {step.next ? (
                        <div>
                            <small className="text-light ">
                                (Step:
                                {" "}
                                {stepIndex + 1}
                                {" "}
                                /
                                {" "}
                                {STEPS.length}
                                )
                            </small>
                        </div>
                    ) : (
                        <button
                            className="text-white btn btn-primary"
                            type="button"
                            onClick={onDoneOnboarding}
                        >
                            Finish Setup
                        </button>
                    )}

                    {step.next ? (
                        <NavLink
                            className="text-light text-center btn btn-link p-0 m-0 "
                            to={Paths.ONBOARDING_STEP}
                            params={{ stepId: step.next }}
                        >
                            Skip
                        </NavLink>
                    ) : (
                        <div />
                    )}

                </div>

            </div>
        </div>

    );
}
